import Glide from "@glidejs/glide";
import { getElements, ifSelectorExist } from "./utils";

export const jpcarrollSliders = () => {
  const areasSlider = getElements(".areas-jpcarroll-block--slider");
  if (ifSelectorExist(areasSlider)) {
    Array.from(areasSlider).forEach((item) => {
      new Glide(item, {
        perView: 1,
        type: "carousel",
        animationDuration: 1000,
      }).mount();
    });
  }
  const dealersSlider = getElements(".dealers-jpcarroll-block--slider-mobile");
  if (ifSelectorExist(dealersSlider)) {
    Array.from(dealersSlider).forEach((item) => {
      new Glide(item, {
        perView: 3.5,
        type: "carousel",
        gap: 15,
        animationDuration: 1000,
        breakpoints: {
          540: {
            perView: 2.3,
          },
        },
      }).mount();
    });
  }
  const qualityItemsSlider = getElements(
    ".quality-items-jpcarroll-block--slider-mobile"
  );
  if (ifSelectorExist(qualityItemsSlider)) {
    Array.from(qualityItemsSlider).forEach((item) => {
      new Glide(item, {
        perView: 1,
        type: "carousel",
        gap: 20,
        autoplay: 3000,
        animationDuration: 1500,
      }).mount();
    });
  }
  const reviewsMobileSlider = getElements(".reviews_mobile_slider");
  if (ifSelectorExist(reviewsMobileSlider)) {
    Array.from(reviewsMobileSlider).forEach((item) => {
      new Glide(item, {
        gap: 30,
        perView: 1,
        type: "carousel",
      }).mount();
    });
  }
  const teamSlider = getElements(".team-jpcarroll-block--slider-test");
  if (ifSelectorExist(teamSlider)) {
    Array.from(teamSlider).forEach((item) => {
      new Glide(item, {
        gap: 45,
        perView: 5,
        type: "carousel",
        animationDuration: 500,
        breakpoints: {
          1200: {
            perView: 4,
          },
          992: {
            perView: 3,
          },
          640: {
            perView: 2,
          },
          400: {
            perView: 1.7,
          },
        },
      }).mount();
    });
  }
  const testimonialsBlockSlider = getElements(
    ".jpcarroll-testimonials-block__slider"
  );
  if (ifSelectorExist(testimonialsBlockSlider)) {
    Array.from(testimonialsBlockSlider).forEach((item) => {
      const glide = new Glide(item, {
        type: "carousel",
        gap: 0,
        perView: 3,
        breakpoints: {
          1024: {
            perView: 2,
          },
          640: {
            perView: 1.2,
          },
        },
      });
      glide.mount();
    });
  }
};
